export default __webpack_public_path__ + "assets/front/scss/recherche/astuces/styles.00e630140ae2e08cc0df5dda558ef841.css";